import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkbox", "disabled"];

  connect() {
    this.toggle();
  }

  toggle() {
    if (this.checkboxTarget.checked) {
      this.disabledTarget.setAttribute("aria-disabled", "false");
    } else {
      this.disabledTarget.setAttribute("aria-disabled", "true");
    }
  }
}
